module.exports = __webpack_public_path__ + "images/info.40b2e1c7.png";